export type ArtifactType = 'screenshot' | 'video' | 'preview-url' | 'email-draft' | 'document' | 'code-diff'
export type ArtifactStatus = 'pending' | 'delivered' | 'refined' | 'approved' | 'discarded' | 'refining'

export interface Artifact {
  id: string
  type: ArtifactType
  status: ArtifactStatus
  title: string
  description: string
  source: string
  workflow: string
  actionId?: string
}

export const APPROVE_LABELS: Record<ArtifactType, string> = {
  'screenshot': 'Approve',
  'video': 'Approve',
  'preview-url': 'Approve',
  'email-draft': 'Send',
  'document': 'Approve',
  'code-diff': 'Approve',
}

export const SHOW_DISCARD: Set<ArtifactType> = new Set(['email-draft'])

export const TYPE_COLORS: Record<ArtifactType, string> = {
  'screenshot': '#4a9a9a',
  'video': '#9b59b6',
  'preview-url': '#3498db',
  'email-draft': '#e8a84c',
  'document': '#4a9a9a',
  'code-diff': '#7ee787',
}

export const TYPE_LABELS: Record<ArtifactType, string> = {
  'screenshot': 'screenshot',
  'video': 'video',
  'preview-url': 'preview-url',
  'email-draft': 'email-draft',
  'document': 'document',
  'code-diff': 'code-diff',
}

export const STATUS_COLORS: Record<ArtifactStatus, { bg: string; text: string }> = {
  pending: { bg: '#e8a84c22', text: '#e8a84c' },
  delivered: { bg: '#4a9a9a22', text: '#4a9a9a' },
  refined: { bg: '#4a9a9a22', text: '#4a9a9a' },
  approved: { bg: '#ffffff08', text: '#8a8680' },
  discarded: { bg: '#ffffff08', text: '#8a8680' },
  refining: { bg: '#9b59b622', text: '#9b59b6' },
}

export const STATUS_LABELS: Record<ArtifactStatus, string> = {
  pending: 'pending review',
  delivered: 'delivered',
  refined: 'refined',
  approved: 'approved',
  discarded: 'discarded',
  refining: 'refining...',
}

export const SAMPLE_ARTIFACTS: Artifact[] = [
  {
    id: 'art-1', type: 'screenshot', status: 'pending',
    title: 'Dashboard after dark mode changes',
    description: 'Playwright capture from staging deploy',
    source: 'codeman/claude-code', workflow: 'code-task', actionId: 'a2',
  },
  {
    id: 'art-2', type: 'video', status: 'pending',
    title: 'Dark mode toggle walkthrough',
    description: 'Playwright recording \u2014 2:01 \u2014 system preference detection',
    source: 'codeman/claude-code', workflow: 'code-task',
  },
  {
    id: 'art-3', type: 'preview-url', status: 'pending',
    title: 'PR #42 \u2014 Live preview',
    description: 'Vercel preview deploy \u2014 dark mode + onboarding',
    source: 'codeman/claude-code', workflow: 'code-task',
  },
  {
    id: 'art-4', type: 'email-draft', status: 'pending',
    title: 'Email to Joe \u2014 Thursday meeting',
    description: 'From voice: \u201cemail Joe about Thursday\u201d',
    source: 'send-email', workflow: 'send-email', actionId: 'a1',
  },
  {
    id: 'art-5', type: 'document', status: 'delivered',
    title: 'Rate Limiting Proposal',
    description: 'Research workflow from Jira ZEN-142',
    source: 'research', workflow: 'complex-research', actionId: 'a3',
  },
  {
    id: 'art-6', type: 'code-diff', status: 'pending',
    title: 'Dark mode toggle \u2014 3 files changed',
    description: 'PR #42 from codeman/claude-code',
    source: 'codeman/claude-code', workflow: 'code-task', actionId: 'a7',
  },
]
